import { css } from '@emotion/css'
import React from 'react'

const STYLES_TAB_CONTAINER = css`
  border-radius: 6px;
`
const STYLES_TAB_CONTENT = css`
  padding: 20px;
`

const STYLES_TAB_LIST = css`
  border-bottom: 1px solid #ccc;
  padding-left: 0;
`

const STYLES_TAB_LIST_ITEM = css`
  display: inline-block;
  position: relative;
  color: #000;
  min-width: 150px;
  list-style: none;
  text-align: center;
  margin-bottom: -1px;
  font-family: 'Roboto', 'Helvetica Neue', Arial, sans-serif;
  :hover {
    cursor: pointer;
  }
  font-family: 'PayPal Sans Big', 'Helvetica Neue', Arial, sans-serif;
  font-weight: 500;
`

const STYLES_TAB_LIST_ACTIVE = css`
  background-color: white;
  background: #fff;
  color: #0070ba;
  border-radius: 4px;
  &:after {
    position: absolute;
    content: '';
    height: 3px;
    bottom: -8px;
    margin: 0 auto;
    left: 0;
    right: 0;
    width: 100%;
    background: #0070ba;
    -o-transition: 0.5s;
    -ms-transition: 0.5s;
    -moz-transition: 0.5s;
    -webkit-transition: 0.5s;
    transition: 0.5s;
  }
`

const TabButtonLight = ({ activeTab, label, onClick }: any) => {
  const handleClick = () => onClick(label)

  const classNames = [STYLES_TAB_LIST_ITEM]
  if (activeTab === label) {
    classNames.push(STYLES_TAB_LIST_ACTIVE)
  }

  return (
    <li className={classNames.join(' ')} onClick={handleClick}>
      {label}
    </li>
  )
}

/**
 * Dummy emelent, needed for `<Tabs/>` component to work properly
 */
export const ContentTab = ({ children }: any) => children

/**
 * @example
 * <Tabs>
 *   <Tab label="Tab1">Tab 1 content...</Tab>
 *   <Tab label="Tab2">Tab 2 content...</Tab>
 * </Tabs>
 */
export const ContentTabs = ({ children }: any) => {
  const [activeTab, setActiveTab] = React.useState(children[0].props.label)

  return (
    <div className={STYLES_TAB_CONTAINER + ' newTabs-container-light'}>
      <ol className={STYLES_TAB_LIST + ' newTabs-orderedList-light'}>
        {children.map((child: { props: { label: any } }) => {
          const { label } = child.props
          return (
            <TabButtonLight
              activeTab={activeTab}
              key={label}
              label={label}
              onClick={setActiveTab}
            />
          )
        })}
      </ol>
      <div className={STYLES_TAB_CONTENT}>
        {children.map((child: { props: { label: any; children: any } }) => {
          if (child.props.label !== activeTab) {
            return
          }
          return child.props.children
        })}
      </div>
    </div>
  )
}
